import { render, staticRenderFns } from "./OttawaKneeJointFracture.vue?vue&type=template&id=c8bbcda2&scoped=true&"
import script from "./OttawaKneeJointFracture.vue?vue&type=script&lang=js&"
export * from "./OttawaKneeJointFracture.vue?vue&type=script&lang=js&"
import style0 from "./OttawaKneeJointFracture.vue?vue&type=style&index=0&id=c8bbcda2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bbcda2",
  null
  
)

export default component.exports